import styled from "styled-components";

export const MenuContainer = styled.div(({ theme }) => ({
    position: "absolute",
    zIndex: "1",
    background: theme.colorMode === "light" ? "#FFFBF7" : theme.colors.dark.canvas_Primary,
    height: "100%",
    // TODO: Remove this once we have a proper solution for the padding issue in the grid container
    // TODO: We will be introducing grid widget 2.0 where this will be fixed
    "& #DinoutItemCollectionBanner": {
        paddingLeft: "0 !important",
    },
    "& #DinoutItemCollectionBanner .row > div:first-child": {
        paddingLeft: theme.spacing.medium,
    },
    "& #DinoutItemCollectionBanner .row > div:last-child": {
        paddingRight: theme.spacing.xSmall,
    },
}));

export const BackIcon = styled.div`
    width: 30px;
    height: 30px;
    flex-shrink: 0;
    position: absolute;
    top: 45px;
    left: 20px;
    background: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ErrorContainer = styled.div`
    width: 100vw;
`;

export const OverLayLoader = styled("div")(({ theme }) => ({
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: theme.colors[theme.colorMode].canvas_Primary,
}));

export const OverLayLoaderForCurtain = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: theme.colors[theme.colorMode].canvas_Primary,
}));
